<template>
  <!-- 小企业 资产负债表-->
  <div>
    <div class="big_box4">
      <div class="top_title3">
        <h5>资产负债表</h5>
        <div class="bottom_font clearfix">
          <h6 class="left">纳税人名称：<span>{{comName}}</span></h6>
          <h6 class="center"><span>{{durationOfTaxTime}}</span></h6>
          <h6 class="right">
            <p>单位：元</p> 
            <p>纳税人识别号：<span>{{taxNo}}</span></p>
          </h6>
        </div>
      </div>
      <table class="content" cellspacing="0" width="100%" >
        <tr class="top_bg">
          <td class="center" style="width:21%;">资产</td>
          <td class="center" style="width:4%;">行次</td>
          <td class="center" style="width:12%;">期末余额</td>
          <td class="center" style="width:12%;">年初余额</td>
          <td class="center" style="width:21%;">负债及所有者权益</td>
          <td class="center" style="width:4%;">行次</td>
          <td class="center" style="width:12%;">期末余额</td>
          <td class="center" style="width:12%;">年初余额</td>
        </tr>
      </table>
      <div class="fixed_box_table" :style="{height:contentStyleObj}">
        <table class="content" cellspacing="0">
          <tr>
            <td style="width:21%;">流动资产：</td>
            <td style="width:4%;" class="center"></td>
            <td style="width:12%;"><span></span></td>
            <td style="width:12%;"><span></span></td>
            <td style="width:21%;">流动负债：</td>
            <td style="width:4%;" class="center"></td>
            <td style="width:12%;"><span></span></td>
            <td style="width:12%;"><span></span></td>
          </tr>

          <tr>
            <td class="left_k">货币资金</td>
            <td class="center">1</td>
            <qzf-td :disabled="false" v-model:amount="list[0].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[0].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k">短期借款</td>
            <td class="center">31</td>
            <qzf-td :disabled="false" v-model:amount="list[0].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[0].ncyeQy" @change="changeList()"></qzf-td>
          </tr>

          <tr>
            <td class="left_k">短期投资</td>
            <td class="center">2</td>
            <qzf-td :disabled="false" v-model:amount="list[1].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[1].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k">应付票据</td>
            <td class="center">32</td>
            <qzf-td :disabled="false" v-model:amount="list[1].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[1].ncyeQy" @change="changeList()"></qzf-td>
          </tr>
          <tr>
            <td class="left_k">应收票据</td>
            <td class="center">3</td>
            <qzf-td :disabled="false" v-model:amount="list[2].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[2].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k">应付账款</td>
            <td class="center">33</td>
            <qzf-td :disabled="false" v-model:amount="list[2].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[2].ncyeQy" @change="changeList()"></qzf-td>
          </tr>

          <tr>
            <td class="left_k">应收账款</td>
            <td class="center">4</td>
            <qzf-td :disabled="false" v-model:amount="list[3].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[3].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k">预收账款</td>
            <td class="center">34</td>
            <qzf-td :disabled="false" v-model:amount="list[3].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[3].ncyeQy" @change="changeList()"></qzf-td>
          </tr>

          <tr>
            <td class="left_k">预付账款</td>
            <td class="center">5</td>
            <qzf-td :disabled="false" v-model:amount="list[4].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[4].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k">应付职工薪酬</td>
            <td class="center">35</td>
            <qzf-td :disabled="false" v-model:amount="list[4].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[4].ncyeQy" @change="changeList()"></qzf-td>
          </tr>

          <tr>
            <td class="left_k">应收股利</td>
            <td class="center">6</td>
            <qzf-td :disabled="false" v-model:amount="list[5].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[5].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k">应交税费</td>
            <td class="center">36</td>
            <qzf-td :disabled="false" v-model:amount="list[5].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[5].ncyeQy" @change="changeList()"></qzf-td>
          </tr>

          <tr>
            <td class="left_k">应收利息</td>
            <td class="center">7</td>
            <qzf-td :disabled="false" v-model:amount="list[6].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[6].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k">应付利息</td>
            <td class="center">37</td>
            <qzf-td :disabled="false" v-model:amount="list[6].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[6].ncyeQy" @change="changeList()"></qzf-td>
          </tr>

          <tr>
            <td class="left_k">其他应收款</td>
            <td class="center">8</td>
            <qzf-td :disabled="false" v-model:amount="list[7].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[7].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k">应付利润</td>
            <td class="center">38</td>
            <qzf-td :disabled="false" v-model:amount="list[7].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[7].ncyeQy" @change="changeList()"></qzf-td>
          </tr>

          <tr>
            <td class="left_k">存货</td>
            <td class="center">9</td>
            <qzf-td :disabled="false" v-model:amount="list[8].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[8].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k">其他应付款</td>
            <td class="center">39</td>
            <qzf-td :disabled="false" v-model:amount="list[8].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[8].ncyeQy" @change="changeList()"></qzf-td>
          </tr>

          <tr>
            <td class="left_k">其中：原材料</td>
            <td class="center">10</td>
            <qzf-td :disabled="false" v-model:amount="list[9].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[9].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k">其他流动负债</td>
            <td class="center">40</td>
            <qzf-td :disabled="false" v-model:amount="list[9].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[9].ncyeQy" @change="changeList()"></qzf-td>
          </tr>

          <tr>
            <td class="left_k">在产品</td>
            <td class="center">11</td>
            <qzf-td :disabled="false" v-model:amount="list[10].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[10].ncyeZc" @change="changeList()"></qzf-td>
            <td class="center weight">流动负债合计</td>
            <td class="center">41</td>
            <qzf-td :disabled="true" v-model:amount="list[10].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="true" v-model:amount="list[10].ncyeQy" @change="changeList()"></qzf-td>
          </tr>

          <tr>
            <td class="left_k">库存商品</td>
            <td class="center">12</td>
            <qzf-td :disabled="false" v-model:amount="list[11].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[11].ncyeZc" @change="changeList()"></qzf-td>
            <td>非流动负债：</td>
            <td class="center"></td>
            <td><span></span></td>
            <td><span></span></td>
          </tr>

          <tr>
            <td class="left_k">周转材料</td>
            <td class="center">13</td>
            <qzf-td :disabled="false" v-model:amount="list[12].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[12].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k">长期借款</td>
            <td class="center">42</td>
            <qzf-td :disabled="false" v-model:amount="list[12].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[12].ncyeQy" @change="changeList()"></qzf-td>
          </tr>

          <tr>
            <td class="left_k">其他流动资产</td>
            <td class="center">14</td>
            <qzf-td :disabled="false" v-model:amount="list[13].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[13].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k">长期应付款</td>
            <td class="center">43</td>
            <qzf-td :disabled="false" v-model:amount="list[13].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[13].ncyeQy" @change="changeList()"></qzf-td>
          </tr>

          <tr>
            <td class="center weight">流动资产合计</td>
            <td class="center">15</td>
            <qzf-td :disabled="true" v-model:amount="list[14].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="true" v-model:amount="list[14].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k">递延收益</td>
            <td class="center">44</td>
            <qzf-td :disabled="false" v-model:amount="list[14].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[14].ncyeQy" @change="changeList()"></qzf-td>
          </tr>

          <tr>
            <td>非流动资产：</td>
            <td class="center"></td>
            <td><span></span></td>
            <td><span></span></td>
            <td class="left_k">其他非流动负债</td>
            <td class="center">45</td>
            <qzf-td :disabled="false" v-model:amount="list[15].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[15].ncyeQy" @change="changeList()"></qzf-td>
          </tr>

          <tr>
            <td class="left_k">长期债券投资</td>
            <td class="center">16</td>
            <qzf-td :disabled="false" v-model:amount="list[16].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[16].ncyeZc" @change="changeList()"></qzf-td>
            <td class="center weight">非流动负债合计</td>
            <td class="center">46</td>
            <qzf-td :disabled="true" v-model:amount="list[16].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="true" v-model:amount="list[16].ncyeQy" @change="changeList()"></qzf-td>
          </tr>

          <tr>
            <td class="left_k">长期股权投资</td>
            <td class="center">17</td>
            <qzf-td :disabled="false" v-model:amount="list[17].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[17].ncyeZc" @change="changeList()"></qzf-td>
            <td class="center weight">负债合计</td>
            <td class="center">47</td>
            <qzf-td :disabled="true" v-model:amount="list[17].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="true" v-model:amount="list[17].ncyeQy" @change="changeList()"></qzf-td>
          </tr>

          <tr>
            <td class="left_k">固定资产原价</td>
            <td class="center">18</td>
            <qzf-td :disabled="false" v-model:amount="list[18].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[18].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k"></td>
            <td class="center"></td>
            <td><span></span></td>
            <td><span></span></td>
          </tr>

          <tr>
            <td class="left_k">减：累计折旧</td>
            <td class="center">19</td>
            <qzf-td :disabled="false" v-model:amount="list[19].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[19].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k"></td>
            <td class="center"></td>
            <td><span></span></td>
            <td><span></span></td>
          </tr>

          <tr>
            <td class="left_k">固定资产账面价值</td>
            <td class="center">20</td>
            <qzf-td :disabled="false" v-model:amount="list[20].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[20].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k"></td>
            <td class="center"></td>
            <td><span></span></td>
            <td><span></span></td>
          </tr>

          <tr>
            <td class="left_k">在建工程</td>
            <td class="center">21</td>
            <qzf-td :disabled="false" v-model:amount="list[21].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[21].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k"></td>
            <td class="center"></td>
            <td><span></span></td>
            <td><span></span></td>
          </tr>

          <tr>
            <td class="left_k">工程物资</td>
            <td class="center">22</td>
            <qzf-td :disabled="false" v-model:amount="list[22].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[22].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k"></td>
            <td class="center"></td>
            <td><span></span></td>
            <td><span></span></td>
          </tr>

          <tr>
            <td class="left_k">固定资产清理</td>
            <td class="center">23</td>
            <qzf-td :disabled="false" v-model:amount="list[23].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[23].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k"></td>
            <td class="center"></td>
            <td><span></span></td>
            <td><span></span></td>
          </tr>

          <tr>
            <td class="left_k">生产性生物资产</td>
            <td class="center">24</td>
            <qzf-td :disabled="false" v-model:amount="list[24].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[24].ncyeZc" @change="changeList()"></qzf-td>
            <td>所有者权益：</td>
            <td class="center"></td>
            <td><span></span></td>
            <td><span></span></td>
          </tr>

          <tr>
            <td class="left_k">无形资产</td>
            <td class="center">25</td>
            <qzf-td :disabled="false" v-model:amount="list[25].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[25].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k">实收资本（或股本）</td>
            <td class="center">48</td>
            <qzf-td :disabled="false" v-model:amount="list[25].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[25].ncyeQy" @change="changeList()"></qzf-td>
          </tr>

          <tr>
            <td class="left_k">开发支出</td>
            <td class="center">26</td>
            <qzf-td :disabled="false" v-model:amount="list[26].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[26].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k">资本公积</td>
            <td class="center">49</td>
            <qzf-td :disabled="false" v-model:amount="list[26].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[26].ncyeQy" @change="changeList()"></qzf-td>
          </tr>

          <tr>
            <td class="left_k">长期待摊费用</td>
            <td class="center">27</td>
            <qzf-td :disabled="false" v-model:amount="list[27].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[27].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k">盈余公积</td>
            <td class="center">50</td>
            <qzf-td :disabled="false" v-model:amount="list[27].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[27].ncyeQy" @change="changeList()"></qzf-td>
          </tr>

          <tr>
            <td class="left_k">其他非流动资产</td>
            <td class="center">28</td>
            <qzf-td :disabled="false" v-model:amount="list[28].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[28].ncyeZc" @change="changeList()"></qzf-td>
            <td class="left_k">未分配利润</td>
            <td class="center">51</td>
            <qzf-td :disabled="false" v-model:amount="list[28].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="false" v-model:amount="list[28].ncyeQy" @change="changeList()"></qzf-td>
          </tr>

          <tr>
            <td class="center weight">非流动资产合计</td>
            <td class="center">29</td>
            <qzf-td :disabled="true" v-model:amount="list[29].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="true" v-model:amount="list[29].ncyeZc" @change="changeList()"></qzf-td>
            <td class="center weight">所有者权益合计</td>
            <td class="center">52</td>
            <qzf-td :disabled="true" v-model:amount="list[29].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="true" v-model:amount="list[29].ncyeQy" @change="changeList()"></qzf-td>
          </tr>

          <tr>
            <td class="center weight">资产合计</td>
            <td class="center">30</td>
            <qzf-td :disabled="true" v-model:amount="list[30].qmyeZc" @change="changeList()"></qzf-td>
            <qzf-td :disabled="true" v-model:amount="list[30].ncyeZc" @change="changeList()"></qzf-td>
            <td class="center weight">负债和所有者权益合计</td>
            <td class="center">53</td>
            <qzf-td :disabled="true" v-model:amount="list[30].qmyeQy" @change="changeList()"></qzf-td>
            <qzf-td :disabled="true" v-model:amount="list[30].ncyeQy" @change="changeList()"></qzf-td>
          </tr>
        </table>
      </div>

    </div>
    <div class="save_box" v-if="this.typeName != '历史数据' && $buttonStatus('kjbb_bc')">
      <el-button @click="saveZcfz" type="primary" size="small"  v-if="this.startAccountPeriod">
        <i class="iconfont icon-baocun" style="margin-right:4px;font-size: 14px;"></i>
        <span  > 保存</span>
      </el-button>
      <qzf-button @success="saveZcfz" type="primary" size="small"  v-else>
        <i class="iconfont icon-baocun" style="margin-right:4px;font-size: 14px;"></i>
        <span  > 保存</span>
      </qzf-button>
    </div>
  </div>
  
</template>

<script>
import { gsInfo , gsEdit} from '@/api/taxCalculation.js'
import { hisZcfzInfo } from '@/api/old.js'
export default {
  name: 'zcfzTable',
  components: { },
  props: {
    typeName: {
      default:'',
      type:String
    },
    startAccountPeriod:{
      default:'',
      type:String
    },
    comId:{
      default:0,
      type:Number
    },
  },
  data() {
    return {
      list:[{"id":156,"kjMainId":14,"type":1,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":157,"kjMainId":14,"type":2,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":158,"kjMainId":14,"type":3,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":159,"kjMainId":14,"type":4,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":160,"kjMainId":14,"type":5,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":161,"kjMainId":14,"type":6,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":162,"kjMainId":14,"type":7,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":163,"kjMainId":14,"type":8,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":164,"kjMainId":14,"type":9,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":165,"kjMainId":14,"type":10,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":166,"kjMainId":14,"type":11,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":167,"kjMainId":14,"type":12,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":168,"kjMainId":14,"type":13,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":169,"kjMainId":14,"type":14,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":170,"kjMainId":14,"type":15,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":171,"kjMainId":14,"type":16,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":172,"kjMainId":14,"type":17,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":173,"kjMainId":14,"type":18,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":174,"kjMainId":14,"type":19,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":175,"kjMainId":14,"type":20,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":176,"kjMainId":14,"type":21,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":177,"kjMainId":14,"type":22,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":178,"kjMainId":14,"type":23,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":179,"kjMainId":14,"type":24,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":180,"kjMainId":14,"type":25,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":181,"kjMainId":14,"type":26,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":182,"kjMainId":14,"type":27,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":183,"kjMainId":14,"type":28,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":184,"kjMainId":14,"type":29,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":185,"kjMainId":14,"type":30,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":186,"kjMainId":14,"type":31,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0}],
      contentStyleObj:{}, //高度变化
      comName:'',
      durationOfTaxTime:'',
      taxNo:'',
    }
  },
  created() {
    // 获取窗口高度
    this.contentStyleObj=this.$getHeight(356)
    this.getList()
  },
  methods: {
    changeList(){
      //流动资产合计
      this.list[14].qmyeZc = (this.list[0].qmyeZc + 
                              this.list[1].qmyeZc + 
                              this.list[2].qmyeZc + 
                              this.list[3].qmyeZc + 
                              this.list[4].qmyeZc + 
                              this.list[5].qmyeZc + 
                              this.list[6].qmyeZc + 
                              this.list[7].qmyeZc +
                              this.list[8].qmyeZc +
                              // this.list[12].qmyeZc +
                              this.list[13].qmyeZc).toFixed(2)*1
      this.list[14].ncyeZc = (this.list[0].ncyeZc + 
                              this.list[1].ncyeZc + 
                              this.list[2].ncyeZc + 
                              this.list[3].ncyeZc + 
                              this.list[4].ncyeZc + 
                              this.list[5].ncyeZc + 
                              this.list[6].ncyeZc + 
                              this.list[7].ncyeZc +
                              this.list[8].ncyeZc +
                              // this.list[12].ncyeZc +
                              this.list[13].ncyeZc).toFixed(2)*1
      //非流动资产合计
      this.list[29].qmyeZc = (this.list[16].qmyeZc + 
                              this.list[17].qmyeZc +
                              // this.list[18].qmyeZc -
                              // this.list[19].qmyeZc + 
                              this.list[20].qmyeZc + 
                              this.list[21].qmyeZc + 
                              this.list[22].qmyeZc + 
                              this.list[23].qmyeZc + 
                              this.list[24].qmyeZc + 
                              this.list[25].qmyeZc +
                              this.list[26].qmyeZc +
                              this.list[27].qmyeZc +
                              this.list[28].qmyeZc).toFixed(2)*1
      this.list[29].ncyeZc = (this.list[16].ncyeZc + 
                              this.list[17].ncyeZc +
                              // this.list[18].ncyeZc -
                              // this.list[19].ncyeZc + 
                              this.list[20].ncyeZc + 
                              this.list[21].ncyeZc + 
                              this.list[22].ncyeZc + 
                              this.list[23].ncyeZc + 
                              this.list[24].ncyeZc + 
                              this.list[25].ncyeZc +
                              this.list[26].ncyeZc +
                              this.list[27].ncyeZc +
                              this.list[28].ncyeZc).toFixed(2)*1
      //资产合计
      this.list[30].qmyeZc = (this.list[14].qmyeZc + 
                              this.list[29].qmyeZc).toFixed(2)*1
      this.list[30].ncyeZc = (this.list[14].ncyeZc + 
                              this.list[29].ncyeZc).toFixed(2)*1
      // 流动负债合计
      this.list[10].qmyeQy = (this.list[0].qmyeQy + 
                              this.list[1].qmyeQy + 
                              this.list[2].qmyeQy + 
                              this.list[3].qmyeQy + 
                              this.list[4].qmyeQy + 
                              this.list[5].qmyeQy + 
                              this.list[6].qmyeQy + 
                              this.list[7].qmyeQy +
                              this.list[8].qmyeQy +
                              this.list[9].qmyeQy).toFixed(2)*1
      this.list[10].ncyeQy = (this.list[0].ncyeQy + 
                              this.list[1].ncyeQy + 
                              this.list[2].ncyeQy + 
                              this.list[3].ncyeQy + 
                              this.list[4].ncyeQy + 
                              this.list[5].ncyeQy + 
                              this.list[6].ncyeQy + 
                              this.list[7].ncyeQy +
                              this.list[8].ncyeQy +
                              this.list[9].ncyeQy).toFixed(2)*1
      // 非流动负债合计
      this.list[16].qmyeQy = (this.list[12].qmyeQy + 
                              this.list[13].qmyeQy + 
                              this.list[14].qmyeQy +
                              this.list[15].qmyeQy).toFixed(2)*1
      this.list[16].ncyeQy = (this.list[12].ncyeQy + 
                              this.list[13].ncyeQy + 
                              this.list[14].ncyeQy + 
                              this.list[15].ncyeQy).toFixed(2)*1
      // 负债合计
      this.list[17].qmyeQy = (this.list[10].qmyeQy + 
                              this.list[16].qmyeQy).toFixed(2)*1                        
      this.list[17].ncyeQy = (this.list[10].ncyeQy + 
                              this.list[16].ncyeQy).toFixed(2)*1
      // 所有者权益合计
      this.list[29].qmyeQy = (this.list[25].qmyeQy + 
                              this.list[26].qmyeQy +
                              this.list[27].qmyeQy +
                              this.list[28].qmyeQy).toFixed(2)*1
      this.list[29].ncyeQy = (this.list[25].ncyeQy + 
                              this.list[26].ncyeQy +
                              this.list[27].ncyeQy +
                              this.list[28].ncyeQy).toFixed(2)*1
      // 负债和所有者权益合计
      this.list[30].qmyeQy = (this.list[17].qmyeQy + 
                              this.list[29].qmyeQy).toFixed(2)*1
      this.list[30].ncyeQy = (this.list[17].ncyeQy + 
                              this.list[29].ncyeQy).toFixed(2)*1
    },
    getList(period){
      if(this.typeName == '历史数据'){
        let periodZC
        if(period){
          periodZC = period
        } else {
          periodZC = this.$store.getters['user/comInfo'].period;
        }
        hisZcfzInfo({period:periodZC}).then(res=>{
          if(res.data.data.info){
            this.list = res.data.data.info
            // this.type = res.data.data.type
          }
        })
      }else if(this.typeName == '会计报表') {
        if(this.startAccountPeriod){
          let param = {
            tableName: 'kj_zcfz',
            period:this.startAccountPeriod,
            comId:this.comId
          }
          gsInfo(param).then(res=>{
            if(res.data.data.info){
              this.list = res.data.data.info
              this.durationOfTaxTime = this.startAccountPeriod
              this.comName = res.data.data.name
              this.taxNo = res.data.data.taxNo
            }
          })
        }else{
          gsInfo({tableName: 'kj_zcfz'}).then(res=>{
            if(res.data.data.info){
              this.list = res.data.data.info
              this.comName = res.data.data.name
              this.taxNo = res.data.data.taxNo
              this.durationOfTaxTime = res.data.data.time
            }
          })
        }
      }
      
    },
    saveZcfz(){
      if(this.startAccountPeriod){
        let param = {
          tableName: 'kj_zcfz',
          period:this.startAccountPeriod,
          comId:this.comId,
          items:this.list
        }
        gsEdit(param).then(res=>{
          if(res.data.msg == "success"){
            this.$qzfMessage("保存成功")
            this.getList()
          }
        })
      }else{
        let param = {
          tableName:'kj_zcfz',
          items:this.list
        }
        gsEdit(param).then(res=>{
          if(res.data.msg == "success"){
            this.$qzfMessage("保存成功")
            this.getList()
          }
        })
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 180px !important;
}
.save_box{
  margin: 0 auto;
  margin-top: 20px;
  text-align: center;
}
.content{
  // width: 2000px;
  width: 100%;
  margin: 0 auto;
  border:1px solid #c2c2c2;
  border-bottom: none;
  border-right: none;
  margin-top: 10px;
 
  span{
    line-height: 28px;
    font-size: 14px;
  }
  tr{
    padding: 0;
    margin: 0;
  }
  td{
    border-right:1px solid #c2c2c2;
    border-bottom:1px solid #c2c2c2;
    line-height: 25px;
    padding:0 6px;
    color: #333;
    font-size: 14px;
  }
}
.left_k{
  text-indent: 2em;
}
.left_b{
  text-indent: 4em;
}
.left_x{
  text-indent:5em;
}
.left_d{
  text-indent:8em;
}
.top_title3{
  width: 100%;
  margin: 0 auto;
  h5{
    font-size: 20px;
    color: #333;
    font-weight: 700;
    text-align: center;
  }
  .bottom_font{
    width: 100%;
    margin: 0 auto;
    margin-top: 10px;
    // position: relative;
    h6{
      float: left;
      width: 33.33%;
      font-size: 14px;
      color: #333;
      font-weight: normal;
      // position: absolute;
      // bottom: 0;
    }
    h6:nth-child(1){
      padding-top: 10px;
    }
    h6:nth-child(2){
      padding-top: 10px;
    }
  }
}
.center{
  text-align: center;
}
.left{
  text-align: left;
}
.right{
  text-align: right;
}
.weight{
  font-weight: 700;
}
.row_box{
  border-bottom: 1px solid #eee;
}
.big_box4{
  width: 98%;
  // padding: 40px;
  background: #fff;
  // box-shadow: 0 2px 10px #ddd;
  margin: 0 auto;
  box-sizing: border-box;
}
.qsly{
  margin: 4px 5px 0 0;
  float: right;
  color: #666;
  // border: 0;
  // background: #fff;
  cursor: pointer;
}
</style>
